import { SymbolType } from 'data/Instrument/types'
import { PriceType, TVMetaType } from 'data/types'

import * as AT from './actionTypes'

export type StopPriceActionType = {
  payload: { readonly granularity: number; readonly symbol: SymbolType }
  type: typeof AT.STOP
}

export type SetRangeActionType = {
  readonly payload: {
    readonly prevRange: string
    readonly range: string
  }
  type: typeof AT.SET_RANGE
}

export type SetPriceCallbackType = {
  readonly payload: {
    readonly liveCallback: (update: PriceType) => void
  }
  type: typeof AT.SET_LIVE_CALLBACK
}

export type ReadPriceActionType = {
  readonly payload: {
    /* eslint-disable */
    readonly callback: (prices: PriceType[], meta: TVMetaType) => void
    readonly from: number
    readonly to: number
    readonly resolution: number
    /* eslint-enable */
  }
  type: typeof AT.READ_BY_DATE
}

export type PriceActionType =
  | { type: typeof AT.READ }
  | ReadPriceActionType
  | { type: typeof AT.RESET }
  | {
      readonly payload: {
        readonly prices: PriceType[]
      }
      type: typeof AT.SET
    }
  | SetRangeActionType
  | { type: typeof AT.TOGGLE_EXPANDED }
  | { type: typeof AT.SET_SUBSCRIBED }
  | {
      readonly payload: {
        readonly price: PriceType
      }
      type: typeof AT.UPDATE
    }
  | SetPriceCallbackType
  | StopPriceActionType

const readByRange = (): PriceActionType => ({
  type: AT.READ
})

const readByDate = (
  callback: (prices: PriceType[], meta: TVMetaType) => void,
  from: number,
  to: number,
  resolution: number
): PriceActionType => ({
  payload: { callback, from, resolution, to },
  type: AT.READ_BY_DATE
})

const reset = (): PriceActionType => ({
  type: AT.RESET
})

const setAll = (prices: PriceType[]): PriceActionType => ({
  payload: { prices },
  type: AT.SET
})

const setRange = (prevRange: string, range: string): PriceActionType => ({
  payload: { prevRange, range },
  type: AT.SET_RANGE
})

const setSubscribed = (): PriceActionType => ({
  type: AT.SET_SUBSCRIBED
})

const setUpdate = (price: PriceType): PriceActionType => ({
  payload: { price },
  type: AT.UPDATE
})

const setLiveCallback = (liveCallback: (update: PriceType) => void): PriceActionType => ({
  payload: { liveCallback },
  type: AT.SET_LIVE_CALLBACK
})

const stop = (symbol: SymbolType, granularity: number): PriceActionType => ({
  payload: { granularity, symbol },
  type: AT.STOP
})

export default {
  readByDate,
  readByRange,
  reset,
  setAll,
  setLiveCallback,
  setRange,
  setSubscribed,
  setUpdate,
  stop
}
